import { render } from "./IsturlerView.vue?vue&type=template&id=655b7190"
import script from "./IsturlerView.vue?vue&type=script&lang=js"
export * from "./IsturlerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__